import { ReactComponent as IconX } from './assets/icon-x.svg';
import { ReactComponent as IconO } from './assets/icon-o.svg';
import { ReactElement } from 'react';

export enum GamePlayer {
  X = 'X',
  O = 'O',
}

export const PlayerX = GamePlayer.X;
export const PlayerO = GamePlayer.O;

export const GamePlayerMark: Record<GamePlayer, ReactElement> = {
  [GamePlayer.X]: <IconX/>,
  [GamePlayer.O]: <IconO/>,
};

export type Color = 'blue' | 'yellow' | 'silver';

export type GridState = (GamePlayer | undefined)[][];

export interface GameState {
  status: 'playing' | 'finished';
  winner: GamePlayer | undefined;
}

export type GameVersus = 'player' | 'cpu';

export interface GameSetup {
  mark: GamePlayer;
  versus: GameVersus;
  score: GameScore;
  started: boolean;
}

export interface GameScore {
  X: number;
  O: number;
  ties: number;
}
